import React from 'react';
import './Portfolio.css';
import { summary, achievements, skillClusters, timeline, lookingFor } from './portfolioData';

const AchievementCard = ({ chapter, title, items }) => (
  <article className="achievement">
    <p className="achievement-chapter">{chapter}</p>
    <h3 className="achievement-title">{title}</h3>
    <dl className="achievement-list">
      {items.map(([label, body]) => (
        <React.Fragment key={label}>
          <dt>{label}</dt>
          <dd>{body}</dd>
        </React.Fragment>
      ))}
    </dl>
  </article>
);

const SkillCluster = ({ title, chips }) => (
  <div className="skill-cluster">
    <h3 className="cluster-title">{title}</h3>
    <div className="chips">
      {chips.map(({ label, strong }) => (
        <span key={label} className={strong ? 'chip chip-strong' : 'chip'}>{label}</span>
      ))}
    </div>
  </div>
);

const TimelineEntry = ({ year, title, body, isCurrent }) => (
  <div className={isCurrent ? 'tl-entry tl-current' : 'tl-entry'}>
    <p className="tl-year">{year}</p>
    <h3 className="tl-title">{title}</h3>
    <p className="tl-body">{body}</p>
  </div>
);

const Portfolio = () => (
  <section className="portfolio">
    <a href="#home" className="back-link">
      <span aria-hidden="true">&larr;</span> Home
    </a>

    <header className="portfolio-hero">
      <p className="eyebrow">Career Portfolio &middot; Meta &middot; 2024–present</p>
      <h1 className="portfolio-name">Jerry Liu</h1>
      <p className="portfolio-lead">{summary}</p>
    </header>

    <section className="portfolio-section">
      <h2 className="section-heading">Selected projects</h2>
      <div className="achievement-stack">
        {achievements.map((a) => (
          <AchievementCard key={a.id} {...a} />
        ))}
      </div>
    </section>

    <section className="portfolio-section">
      <h2 className="section-heading">Technical skills</h2>
      <div className="skills-grid">
        {skillClusters.map((c) => (
          <SkillCluster key={c.title} {...c} />
        ))}
      </div>
    </section>

    <section className="portfolio-section">
      <h2 className="section-heading">Career trajectory</h2>
      <div className="timeline">
        {timeline.map((t) => (
          <TimelineEntry key={t.year} {...t} />
        ))}
      </div>
    </section>

    <section className="portfolio-section">
      <h2 className="section-heading">What I'm looking for</h2>
      <ul className="looking-for">
        {lookingFor.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </section>
  </section>
);

export default Portfolio;
